import { Box, Button, Divider, Typography } from '@mui/material'
import { Loading } from 'components/Loading'
import { Error } from 'components/Error'
import PageWrapper from 'hoc/PageWrapper'
import { useBoolean } from 'hooks/useBoolean'
import { useTranslation } from 'react-i18next'
import { useQueryState } from 'react-router-use-location-state'
import { useNotificationsQuery } from 'services/notification'
import { DialogCreateNotification } from './dialog-create-notification'
import { NotificationCard } from './notification-card'
import { TablePagination } from 'components/TablePagination'
import { useUserCurrentQuery } from 'services/users'
import { EOrganizationType } from 'types/users'

export const Notification = () => {
  const { t } = useTranslation()
  const dialogCreateNotification = useBoolean(false)

  const {
    data: user,
    isLoading: isUserLoading,
    isError: isUserError,
  } = useUserCurrentQuery()

  const [page, setPage] = useQueryState('page', 0)
  const rowsPerPage = 10

  const args = {
    page,
    size: rowsPerPage,
  } as const

  const { data: notifications, isError, isLoading } = useNotificationsQuery(args)

  const canEdit = user?.organizationType === EOrganizationType.TENDER_AUTHORITY

  if (isLoading || isUserLoading) return <Loading />

  if (isError || isUserError) return <Error />

  if (notifications === undefined || user === undefined) {
    return <></>
  }

  return (
    <PageWrapper>
      {dialogCreateNotification.isTrue && (
        <DialogCreateNotification onClose={dialogCreateNotification.setFalse} />
      )}

      <Box display="flex" justifyContent="space-between">
        <Typography fontWeight="bold" variant="h6">
          {t('notifications')}
        </Typography>
        <Button
          color="primary"
          variant="contained"
          style={{ color: '#fff', backgroundColor: 'rgb(3, 34, 76)' }}
          onClick={dialogCreateNotification.setTrue}
          disabled={!canEdit}
        >
          {t('create')}
        </Button>
      </Box>
      <Divider sx={{ my: 1.5 }} />
      {notifications.items.map((notification) => (
        <NotificationCard
          key={notification.id}
          notification={notification}
          canEdit={canEdit}
        />
      ))}
      {notifications.info.totalRows !== 0 && (
        <TablePagination
          total={notifications.info.totalRows}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={setPage}
        />
      )}
    </PageWrapper>
  )
}
